import React, { ReactNode } from "react";
import styles from './agents.module.css';
import global from '../bid.module.css';
import { VariableLink } from "../";

type Props = {
  title: ReactNode,
  data: [
    {
      company_id: string,
      company_name: string,
      logo_uri: string
    }
  ],
  themeFormat: object
}

const Agents = ({ title, data, themeFormat }: Props) => {
  return (
    <section className={styles.Background} id="agents" >
      <div className={`${global.Container} ${styles.Container}`}>
        <h3>{title}</h3>
        <ul className={styles.Logos}> 
          {data.map((logo) => {
            return (
              <li key={logo.company_id}>
                <VariableLink styledAs="wrapper" themeFormat={themeFormat} origin={undefined} href={""} >
                  <img width={'auto'} height={'auto'} loading="lazy" alt={logo.company_name} src={`${process.env.NEXT_PUBLIC_APP_MEDIA_URL}${logo.logo_uri}`} />
                </VariableLink>
              </li>
            )
          })}
        </ul>
      </div>
    </section>
  );
};

export default Agents;
